import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';

import { mainText, subText } from 'utils/translate';
import TranslateContainer from 'challenge/common/TranslateContainer';
import { INDICATOR, GOAL_STATUS } from 'resources/constants';

import Goal from './Goal';
import {
  Wrapper,
  Header,
  BodyWrapper,
  StatsContainer,
  TranslateWrapper,
  Button,
} from './elements';

import { useText, useConfig } from 'common/hooks';

const deps = {
  goals: state.challenge.info.computedGoals,
  currentGoal: state.challenge.info.computedCurrentGoal,
  translate: state.challenge.visualisations.translates.insightsUser,
  indicator: state.challenge.campaign.indicator,
  goalModalClicked: sequences`challenge.info.goalModalClicked`,
};

export function PersonalInsights({
  goals,
  currentGoal,
  translate,
  indicator,
  goalModalClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const { staticUrl, translateImagePath } = useConfig();

  return (
    <Wrapper>
      <Header
        title={t(
          `challenge.ChaPaD24B.PersonalInsights.your_total_savings.${indicator}`
        )}
      />
      <BodyWrapper>
        <Goal />
        {indicator !== INDICATOR.points && (
          <StatsContainer isPlaceholder={!translate}>
            <TranslateWrapper>
              <TranslateContainer
                placeholder={!translate}
                placeholderText={t(
                  'challenge.ChaPaD24B.PersonalInsights.translate.are_you_able'
                )}
                translateImageUrl={staticUrl + translateImagePath}
                mainText={mainText(t, translate?.data)}
                subText={subText(t, translate?.data)}
                translate={{
                  ...translate?.data,
                  units:
                    translate?.data?.units &&
                    t(`translate.units.${translate?.data?.units}`),
                }}
              />
            </TranslateWrapper>
          </StatsContainer>
        )}
        {currentGoal.status === GOAL_STATUS.NONE &&
          goals.some(goal => goal.canBeSet) && (
            <Button onClick={() => goalModalClicked()}>
              {t('challenge.ChaPaD24B.PersonalInsights.goals.set_goal')}
            </Button>
          )}
      </BodyWrapper>
    </Wrapper>
  );
}

export default connect(deps, PersonalInsights);
